import { render, staticRenderFns } from "./CardPremium.vue?vue&type=template&id=49f86fd3&scoped=true&"
import script from "./CardPremium.vue?vue&type=script&lang=js&"
export * from "./CardPremium.vue?vue&type=script&lang=js&"
import style0 from "./CardPremium.vue?vue&type=style&index=0&id=49f86fd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f86fd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
